export default __webpack_public_path__ + "static/media/placeholder_dummy2016-grafikdesigner01-mobile-de.ef0978d0.png";